var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { r as registerInstance, h, H as Host, c as createEvent, g as getElement } from './index-0e9b988c.js';
import { C as CloseBtnTheme } from './index-4dff9680.js';
var css = ":host{position:relative;display:block;width:var(--ispui-close__size, 24px);height:var(--ispui-close__size, 24px)}.ispui-close{display:block;width:100%;height:100%;cursor:pointer;-webkit-transition:background-color 0.2s ease;transition:background-color 0.2s ease;border:none;border-radius:50%;outline:none;background-color:transparent}.ispui-close:focus:not(:disabled)+.ispui-close__focus-border{border:1px solid rgba(24, 122, 189, 0.4);border-radius:3px}.ispui-close::before,.ispui-close::after{content:\"\";position:absolute;top:50%;left:50%;display:block;width:80%;height:var(--ispui-close__line-width, 2px);-webkit-transform:translate(-50%, -50%) rotateZ(45deg);transform:translate(-50%, -50%) rotateZ(45deg);-webkit-transform-origin:center center;transform-origin:center center;border-radius:10px}.ispui-close::after{-webkit-transform:translate(-50%, -50%) rotateZ(-45deg);transform:translate(-50%, -50%) rotateZ(-45deg)}.ispui-close__focus-border{position:absolute;top:-2px;left:-2px;-webkit-box-sizing:border-box;box-sizing:border-box;width:calc(100% + 4px);height:calc(100% + 4px);pointer-events:none}.ispui-close__theme_dark::before,.ispui-close__theme_dark::after{background-color:var(--ispui-close__dark-color, #344a5e)}.ispui-close__theme_dark:hover{background-color:var(--ispui-close__dark-background-color_hover, rgba(52, 74, 94, 0.20621))}.ispui-close__theme_dark:active{background-color:var(--ispui-close__dark-background-color_active, rgba(52, 74, 94, 0.4))}.ispui-close__theme_gray::before,.ispui-close__theme_gray::after{background-color:var(--ispui-close__gray-color, #9b9b9b)}.ispui-close__theme_gray:hover{background-color:var(--ispui-close__gray-background-color_hover, rgba(52, 74, 94, 0.2008))}.ispui-close__theme_gray:active{background-color:var(--ispui-close__gray-background-color_active, rgba(52, 74, 94, 0.4))}.ispui-close__theme_light::before,.ispui-close__theme_light::after{background-color:var(--ispui-close__light-color, #f4f4f4)}.ispui-close__theme_light:hover{background-color:var(--ispui-close__light-background-color_hover, rgba(255, 255, 255, 0.20621))}.ispui-close__theme_light:active{background-color:var(--ispui-close__light-background-color_active, rgba(255, 255, 255, 0.4))}";
var MyComponent = /** @class */ (function () {
    function MyComponent(hostRef) {
        registerInstance(this, hostRef);
        /** Close button theme (state, default = dark) */
        this.closeBtnTheme = CloseBtnTheme.dark;
    }
    /**
     * Validate theme prop
     * @param theme - input theme property
     */
    MyComponent.prototype.validateThemeProp = function (theme) {
        if (!Object.values(CloseBtnTheme).includes(theme)) {
            return;
        }
        this.closeBtnTheme = theme;
    };
    /**
     * Validate size property
     * @param size - input size property
     */
    MyComponent.prototype.validateSizeProp = function (size) {
        /** max size of close btn */
        var maxCloseSize = 1000;
        if (size === null || isNaN(size)) {
            return;
        }
        if (size > 0 && size < maxCloseSize) {
            this.closeBtnSize = size + "px";
        }
        else {
            console.warn('Size must be a number more than 0 and less than 1000');
        }
    };
    /**
     * Validate props on component will load
     */
    MyComponent.prototype.componentWillLoad = function () {
        this.validateThemeProp(this.theme);
        this.validateSizeProp(this.size);
    };
    /**
     * Render function
     */
    MyComponent.prototype.render = function () {
        return (h(Host, { style: { width: this.closeBtnSize, height: this.closeBtnSize }, onMouseDown: function (event) {
                event.preventDefault();
                document.activeElement.blur();
            } }, h("button", { class: "ispui-close ispui-close__theme_" + this.closeBtnTheme }), h("div", { class: "ispui-close__focus-border" })));
    };
    Object.defineProperty(MyComponent, "watchers", {
        get: function () {
            return {
                "theme": ["validateThemeProp"],
                "size": ["validateSizeProp"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return MyComponent;
}());
MyComponent.style = css;
var ISPUIDropdown = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        /** Minimal offset between dropdown and window border */
        this.borderOffset = 20;
        /** Hover debounce time */
        this.hoverDebounceDefault = 300;
        /** Default offset between anchor element and dropdown */
        this.defaultDropdownOffset = 25;
        /** Pointer height (pixels) */
        this.pointerHeight = 20;
        /** Pointer width (pixels) */
        this.pointerWidth = 34;
        /** Pointer offset from dropdown border */
        this.pointerOffset = 20;
        /** Dropdown visibility status */
        this.isVisible = false;
        /** Flag for handle close button existence */
        this.isClose = true;
        /** Flag for handle pointer existence */
        this.hasPointer = true;
        /** Close dropdown on click */
        this.closeAfterClick = false;
        /** Flag for freeze fropdown direction */
        this.strictDirection = false;
        /** Flag for disable dropdown showing */
        this.disabled = false;
        /** Dropdown open type: click | hover */
        this.type = 'click';
        /** Dropdown direction */
        this.direction = 'bottom';
        /** Timeout debounce before show dropdown popup */
        this.hoverDebounce = this.hoverDebounceDefault;
        /** Dropdown alignment */
        this.alignment = 'auto';
        /** Offset between anchor element and dropdown */
        this.offset = this.defaultDropdownOffset;
        this.close = createEvent(this, "close", 7);
        this.open = createEvent(this, "open", 7);
    }
    /**
     * Validate value of hoverDebounce prop
     * @param newHoverDebounce - timeout debounce before show dropdown popup
     */
    class_1.prototype.validateHoverDebounce = function (newHoverDebounce) {
        if (isNaN(newHoverDebounce)) {
            return;
        }
        this.hoverDebounce = newHoverDebounce;
    };
    /**
     * Validate dropdown direction
     * @param newDirection - dropdown direction
     */
    class_1.prototype.validateDirection = function (newDirection) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (['bottom', 'right', 'left', 'top'].includes(newDirection)) {
            this.currentDirection = newDirection;
        }
    };
    /**
     * LIFECYCLE
     *
     * Validate props
     */
    class_1.prototype.componentWillLoad = function () {
        this.validateHoverDebounce(this.hoverDebounce);
        this.validateDirection(this.direction);
    };
    /**
     * LIFECYCLE
     *
     * Form dropdown content
     */
    class_1.prototype.componentDidLoad = function () {
        var _a, _b;
        for (var _i = 0, _c = Array.from(this.hostEl.children); _i < _c.length; _i++) {
            var child = _c[_i];
            if (child.slot === 'anchor') {
                this.anchorEl = child;
            }
            else {
                (_a = this.instance) === null || _a === void 0 ? void 0 : _a.appendChild(child);
            }
        }
        (_b = this.instance) === null || _b === void 0 ? void 0 : _b.addEventListener('animationend', this.listenDropdownAnimation.bind(this));
    };
    /**
     * LIFECYCLE
     *
     * Clear event listeners
     */
    class_1.prototype.componentDidUnload = function () {
        if (this.instance) {
            this.instance.removeEventListener('animationend', this.listenDropdownAnimation.bind(this));
            this.instance.remove();
        }
    };
    /**
     * Handle click on anchor element
     */
    class_1.prototype.handleClick = function () {
        if (this.type === 'click' && !this.disabled) {
            this.toggleDropdown();
        }
    };
    /**
     * Handle mouse enter on anchor element
     */
    class_1.prototype.handleMouseenter = function () {
        var _this = this;
        if (this.type === 'hover' && !this.disabled) {
            if (this.hoverTimeout) {
                window.clearTimeout(this.hoverTimeout);
            }
            if (!this.isVisible) {
                this.hoverTimeout = window.setTimeout(function () { return _this.showDropdown(); }, this.hoverDebounce);
            }
        }
    };
    /**
     * Handle mouse leave on anchor element
     */
    class_1.prototype.handleMouseleave = function () {
        var _this = this;
        if (this.type === 'hover') {
            if (this.hoverTimeout) {
                window.clearTimeout(this.hoverTimeout);
            }
            if (this.isVisible) {
                this.hoverTimeout = window.setTimeout(function () { return _this.closeDropdown(); }, this.hoverDebounce);
            }
        }
    };
    /**
     * Listen window resize for change dropdown position and size
     */
    class_1.prototype.handleWindowScroll = function () {
        var _this = this;
        if (this.resetTimeout) {
            window.clearTimeout(this.resetTimeout);
        }
        this.resetTimeout = window.setTimeout(function () {
            if (_this.isVisible && _this.instance && _this.anchorEl) {
                _this.setupDropdown();
            }
        }, 100);
    };
    /**
     * Handle document clicks
     * @param e - click event
     */
    class_1.prototype.handleDocumentClick = function (_c) {
        var target = _c.target;
        if (this.instance) {
            if ((this.closeAfterClick && this.instance.contains(target)) || (!this.instance.contains(target) && !this.hostEl.contains(target))) {
                this.closeDropdown();
            }
        }
    };
    /**
     * Show dropdow metod
     */
    class_1.prototype.showDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.isVisible = true;
                        (_a = this.instance) === null || _a === void 0 ? void 0 : _a.classList.remove('ispui-dropdown_closing');
                        if (!this.instance) return [3 /*break*/, 2];
                        document.body.appendChild(this.instance);
                        return [4 /*yield*/, this.setupDropdown()];
                    case 1:
                        _c.sent();
                        this.open.emit();
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Close dropdown method
     */
    class_1.prototype.closeDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_c) {
                (_a = this.instance) === null || _a === void 0 ? void 0 : _a.classList.add('ispui-dropdown_closing');
                return [2 /*return*/];
            });
        });
    };
    /**
     * Set pointer position calc function
     * @param callback - callback for calculate pointer position
     */
    class_1.prototype.setPointerPositionCallback = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.pointerPositionCallback = callback;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Calculate height and position for dropdown instance
     */
    class_1.prototype.setupDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dropdownStyles, anchorRect, minWidth;
            return __generator(this, function (_c) {
                if (!this.instance) {
                    return [2 /*return*/];
                }
                this.instance.style.height = '';
                this.instance.style.maxHeight = '';
                this.instance.style.maxWidth = '';
                dropdownStyles = getComputedStyle(this.instance);
                anchorRect = this.anchorEl.getBoundingClientRect();
                this.setMinHeight();
                minWidth = parseInt(dropdownStyles.minWidth);
                this.setDropdownDirection(anchorRect, minWidth);
                this.setHeight();
                this.setMaxWidth(anchorRect);
                this.setMaxHeight(anchorRect);
                this.setDropdownPosition(anchorRect);
                this.setPointerPosition(anchorRect);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Remove dropdown after fade animation out
     * @param e - animation event
     */
    class_1.prototype.listenDropdownAnimation = function (e) {
        if (e.type === 'animationend' && e.animationName === 'fade-out') {
            this.isVisible = false;
            this.instance.remove();
            this.close.emit();
        }
    };
    /**
     * Toggle dropdown state
     */
    class_1.prototype.toggleDropdown = function () {
        if (!this.isVisible) {
            this.showDropdown();
        }
        else {
            this.closeDropdown();
        }
    };
    /**
     * Set dropdown direction
     * @param anchorRect - DOMrect of anchor element
     * @param minWidth - minimal width of dropdown popup
     */
    class_1.prototype.setDropdownDirection = function (anchorRect, minWidth) {
        var minHeight = parseInt(getComputedStyle(this.instance).minHeight);
        if (this.strictDirection) {
            this.currentDirection = this.direction;
            return;
        }
        switch (this.direction) {
            case 'top':
                if (anchorRect.top > minHeight + this.offset + this.borderOffset) {
                    this.currentDirection = 'top';
                }
                else {
                    this.currentDirection = 'bottom';
                }
                break;
            case 'bottom':
                if (document.documentElement.clientHeight - anchorRect.bottom < minHeight + this.offset + this.borderOffset) {
                    this.currentDirection = 'top';
                }
                else {
                    this.currentDirection = 'bottom';
                }
                break;
            case 'left':
                if (anchorRect.left > minWidth + this.offset + this.borderOffset) {
                    this.currentDirection = 'left';
                }
                else {
                    this.currentDirection = 'right';
                }
                break;
            case 'right':
                if (document.documentElement.clientWidth - anchorRect.right > minWidth + this.offset + this.borderOffset) {
                    this.currentDirection = 'right';
                }
                else {
                    this.currentDirection = 'left';
                }
                break;
        }
    };
    /**
     * Set dropdown position
     * @param anchorRect - DOMrect of anchor element
     */
    class_1.prototype.setDropdownPosition = function (anchorRect) {
        if (!this.instance) {
            return;
        }
        this.instance.style.transform = '';
        switch (this.currentDirection) {
            case 'top':
                this.instance.style.top = window.scrollY + anchorRect.top - this.offset + "px";
                this.instance.style.transform = 'translateY(-100%)';
                this.setHorizontalAlign(anchorRect);
                break;
            case 'bottom':
                this.instance.style.top = window.scrollY + anchorRect.bottom + this.offset + "px";
                this.setHorizontalAlign(anchorRect);
                break;
            case 'left':
                this.instance.style.left = window.scrollX + anchorRect.left - this.offset + "px";
                this.instance.style.transform = 'translateX(-100%)';
                this.setVerticalAlign(anchorRect);
                break;
            case 'right':
                this.instance.style.left = window.scrollX + anchorRect.right + this.offset + "px";
                this.setVerticalAlign(anchorRect);
                break;
        }
    };
    /**
     * Set dropdown height
     */
    class_1.prototype.setHeight = function () {
        if (this.instance) {
            this.instance.style.height = this.instance.getBoundingClientRect().height + "px";
        }
    };
    /**
     * Set dropdown max width
     * @param anchorRect - DOMrect of anchor element
     */
    class_1.prototype.setMaxWidth = function (anchorRect) {
        if (!this.instance) {
            return;
        }
        this.instance.style.maxWidth = '';
        var dropdownStyles = getComputedStyle(this.instance);
        var minWidth = parseInt(dropdownStyles.minWidth);
        var maxWidth = parseInt(dropdownStyles.maxWidth);
        var windowWidth = document.documentElement.clientWidth;
        if (this.currentDirection === 'left') {
            maxWidth = Math.min(maxWidth, anchorRect.left - this.borderOffset - this.offset);
        }
        else if (this.currentDirection === 'right') {
            maxWidth = Math.min(maxWidth, windowWidth - this.borderOffset - this.offset - anchorRect.right);
        }
        else {
            switch (this.alignment) {
                case 'start':
                    maxWidth = Math.min(maxWidth, windowWidth - anchorRect.left - this.borderOffset);
                    break;
                case 'middle':
                    maxWidth = Math.min(maxWidth, (Math.min(anchorRect.left + anchorRect.width / 2, windowWidth - anchorRect.left - anchorRect.width / 2) - this.borderOffset) *
                        2);
                    break;
                case 'end':
                    maxWidth = Math.min(maxWidth, anchorRect.right - this.borderOffset);
                    break;
                case 'auto':
                    maxWidth = Math.min(maxWidth, windowWidth - this.borderOffset * 2);
                    break;
            }
        }
        this.instance.style.maxWidth = Math.max(maxWidth, minWidth) + "px";
    };
    /**
     * Set dropdown min height
     */
    class_1.prototype.setMinHeight = function () {
        if (!this.instance) {
            return;
        }
        var currentMinHeight = parseInt(getComputedStyle(this.instance).minHeight);
        var minHeight = 0;
        for (var _i = 0, _c = Array.from(this.instance.children); _i < _c.length; _i++) {
            var child = _c[_i];
            var childStyle = getComputedStyle(child);
            if (parseInt(childStyle.minHeight)) {
                minHeight += parseInt(childStyle.minHeight);
            }
            else {
                minHeight += parseInt(childStyle.height);
            }
        }
        this.instance.style.minHeight = Math.max(currentMinHeight, minHeight) + "px";
    };
    /**
     * Set dropdown max height
     * @param anchorRect - DOMrect of anchor element
     */
    class_1.prototype.setMaxHeight = function (anchorRect) {
        if (!this.instance) {
            return;
        }
        this.instance.style.maxHeight = '';
        var dropdownStyles = getComputedStyle(this.instance);
        var minHeight = parseInt(dropdownStyles.minHeight);
        var maxHeight = parseInt(dropdownStyles.maxHeight);
        var windowHeight = document.documentElement.clientHeight;
        if (this.currentDirection === 'top') {
            maxHeight = Math.min(maxHeight, anchorRect.top - this.borderOffset - this.offset);
        }
        else if (this.currentDirection === 'bottom') {
            maxHeight = Math.min(maxHeight, windowHeight - anchorRect.bottom - this.borderOffset - this.offset);
        }
        else {
            switch (this.alignment) {
                case 'start':
                    maxHeight = Math.min(maxHeight, windowHeight - anchorRect.top - this.borderOffset);
                    break;
                case 'middle':
                    maxHeight = Math.min(maxHeight, (Math.min(anchorRect.top + anchorRect.height / 2, windowHeight - anchorRect.top - anchorRect.height / 2) - this.borderOffset) *
                        2);
                    break;
                case 'end':
                    maxHeight = Math.min(maxHeight, anchorRect.bottom - this.borderOffset);
                    break;
                case 'auto':
                    maxHeight = Math.min(maxHeight, windowHeight - this.borderOffset * 2);
                    break;
            }
        }
        this.instance.style.maxHeight = Math.max(minHeight, maxHeight) + "px";
    };
    /**
     * Set dropdown horizontal position from alignment
     * @param anchorRect - DOMrect of anchor element
     */
    class_1.prototype.setHorizontalAlign = function (anchorRect) {
        if (!this.instance) {
            return;
        }
        var dropdownRect = this.instance.getBoundingClientRect();
        switch (this.alignment) {
            case 'start':
                this.instance.style.left = window.scrollX + anchorRect.left + "px";
                break;
            case 'auto':
            case 'middle':
                var anchorCenter = window.scrollX + anchorRect.left + anchorRect.width / 2;
                var rightBorder = anchorCenter + dropdownRect.width / 2;
                var leftBorder = anchorCenter - dropdownRect.width / 2;
                if (leftBorder < window.scrollX + this.borderOffset) {
                    var minLeft = Math.min(window.scrollX + this.borderOffset, window.scrollX + anchorRect.right - (this.pointerWidth / 2 + this.pointerOffset));
                    this.instance.style.left = minLeft + "px";
                }
                else if (rightBorder > window.scrollX + document.documentElement.clientWidth - this.borderOffset) {
                    var minRight = Math.max(window.scrollX + document.documentElement.clientWidth - this.borderOffset, window.scrollX + anchorRect.left + this.pointerWidth / 2 + this.pointerOffset);
                    this.instance.style.left = minRight - dropdownRect.width + "px";
                }
                else {
                    this.instance.style.left = leftBorder + "px";
                }
                break;
            case 'end':
                this.instance.style.left = window.scrollX + anchorRect.right - dropdownRect.width + "px";
                break;
        }
    };
    /**
     * Set dropdown vertical position from alignment
     * @param anchorRect - DOMrect of anchor element
     */
    class_1.prototype.setVerticalAlign = function (anchorRect) {
        if (!this.instance) {
            return;
        }
        var dropdownRect = this.instance.getBoundingClientRect();
        switch (this.alignment) {
            case 'start':
                this.instance.style.top = window.scrollY + anchorRect.top + "px";
                break;
            case 'auto':
            case 'middle':
                var anchorCenter = window.scrollY + anchorRect.top + anchorRect.height / 2;
                var topBorder = anchorCenter - dropdownRect.height / 2;
                var bottomBorder = anchorCenter + dropdownRect.height / 2;
                if (topBorder < window.scrollY + this.borderOffset) {
                    var minTop = Math.min(window.scrollY + this.borderOffset, window.scrollY + anchorRect.bottom - (this.pointerWidth / 2 + this.pointerOffset));
                    this.instance.style.top = minTop + "px";
                }
                else if (bottomBorder > window.scrollY + document.documentElement.clientHeight - this.borderOffset) {
                    var maxBottom = Math.max(window.scrollY + document.documentElement.clientHeight - this.borderOffset, window.scrollY + anchorRect.bottom + (this.pointerWidth / 2 + this.pointerOffset));
                    this.instance.style.top = maxBottom - dropdownRect.height + "px";
                }
                else {
                    this.instance.style.top = topBorder + "px";
                }
                break;
            case 'end':
                this.instance.style.top = window.scrollY + anchorRect.bottom - dropdownRect.height + "px";
                break;
        }
    };
    /**
     * Set pointer position
     * @param anchorRect - DOMrect of anchor element
     */
    class_1.prototype.setPointerPosition = function (anchorRect) {
        if (!this.instance) {
            return;
        }
        var dropdownRect = this.instance.getBoundingClientRect();
        /** Pointer offset from dropdown border */
        var POINTER_OFFSET = 20;
        if (this.pointerPositionCallback) {
            var pos = this.pointerPositionCallback(anchorRect, dropdownRect, this.pointerWidth);
            switch (this.currentDirection) {
                case 'top':
                case 'bottom':
                    this.instance.style.setProperty('--ispui-dropdown__pointer-left', pos + "px");
                    break;
                case 'left':
                case 'right':
                    this.instance.style.setProperty('--ispui-dropdown__pointer-top', pos + "px");
                    break;
            }
            return;
        }
        switch (this.currentDirection) {
            case 'top':
            case 'bottom':
                var anchorCenter = anchorRect.left + anchorRect.width / 2;
                var xPos = anchorCenter - dropdownRect.left - this.pointerWidth / 2;
                if (anchorCenter < dropdownRect.left + POINTER_OFFSET + this.pointerWidth / 2) {
                    xPos = POINTER_OFFSET;
                }
                else if (anchorCenter > dropdownRect.right - POINTER_OFFSET - this.pointerWidth / 2) {
                    xPos = dropdownRect.width - POINTER_OFFSET - this.pointerWidth;
                }
                this.instance.style.setProperty('--ispui-dropdown__pointer-left', xPos + "px");
                break;
            case 'left':
            case 'right':
                var anchorHeightCenter = anchorRect.top + anchorRect.height / 2;
                var yPos = anchorHeightCenter - dropdownRect.top - this.pointerWidth / 2;
                if (anchorHeightCenter < dropdownRect.top + POINTER_OFFSET + this.pointerWidth / 2) {
                    yPos = POINTER_OFFSET;
                }
                else if (anchorHeightCenter > dropdownRect.bottom - POINTER_OFFSET - this.pointerWidth / 2) {
                    yPos = dropdownRect.height - POINTER_OFFSET - this.pointerWidth;
                }
                this.instance.style.setProperty('--ispui-dropdown__pointer-top', yPos + "px");
                break;
        }
    };
    class_1.prototype.render = function () {
        var _this = this;
        return (h("slot", { name: "anchor" }, h("ispui-dropdown-popup", { isClose: this.isClose, hasPointer: this.hasPointer, direction: this.currentDirection, onCloseClicked: function () { return _this.closeDropdown(); }, onMouseEnter: function () { return _this.handleMouseenter(); }, onMouseLeave: function () { return _this.handleMouseleave(); }, ref: function (el) { return (_this.instance = el); }, zIndex: this.zIndex })));
    };
    Object.defineProperty(class_1.prototype, "hostEl", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "watchers", {
        get: function () {
            return {
                "hoverDebounce": ["validateHoverDebounce"],
                "direction": ["validateDirection"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
var css$1 = ".ispui-dropdown-content{display:-ms-flexbox;display:flex;overflow:hidden;min-height:50px;max-height:inherit;padding:var(--ispui-dropdown-content-padding, 20px)}.ispui-dropdown-popup_has-cross .ispui-dropdown-content{padding:var(--ispui-dropdown-content-padding, 20px 50px 20px 20px)}.ispui-dropdown-popup_has-cross ispui-dropdown-header+.ispui-dropdown-content{padding:var(--ispui-dropdown-content-padding, 20px 20px 20px 20px)}.ispui-dropdown-content__wrapper{overflow-y:auto;max-height:inherit;padding-right:20px;scrollbar-color:var(--ispui-dropdown-scroll-indicator-color, #344a5e) var(--ispui-dropdown-scroll-background-color, #ececec);scrollbar-width:thin;}.ispui-dropdown-content__wrapper::-webkit-scrollbar,.ispui-dropdown-content__wrapper::-webkit-scrollbar-track,.ispui-dropdown-content__wrapper::-webkit-scrollbar-thumb{width:7px;height:7px;border-radius:var(--ispui-dropdown-scrollborder-radius, 10px)}.ispui-dropdown-content__wrapper::-webkit-scrollbar{background:var(--ispui-dropdown-scroll-background-color, #ececec)}.ispui-dropdown-content__wrapper::-webkit-scrollbar-thumb{background:var(--ispui-dropdown-scroll-indicator-color, #344a5e)}.ispui-dropdown-content__wrapper::-webkit-scrollbar-button{display:none}";
var ISPUIDropdownContent = /** @class */ (function () {
    function ISPUIDropdownContent(hostRef) {
        registerInstance(this, hostRef);
    }
    ISPUIDropdownContent.prototype.render = function () {
        return (h(Host, { class: "ispui-dropdown-content" }, h("div", { class: "ispui-dropdown-content__wrapper" }, h("slot", null))));
    };
    return ISPUIDropdownContent;
}());
ISPUIDropdownContent.style = css$1;
var css$2 = ".ispui-dropdown-footer{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;padding:var(--ispui-dropdown-footer-padding, 0 20px 25px 20px);border-top:1px solid var(--ispui-dropdown-footer-border-color, transparent)}";
var ISPUIDropdownFooter = /** @class */ (function () {
    function ISPUIDropdownFooter(hostRef) {
        registerInstance(this, hostRef);
    }
    ISPUIDropdownFooter.prototype.render = function () {
        return (h(Host, { slot: "dropdown-footer", class: "ispui-dropdown-footer" }, h("slot", null)));
    };
    return ISPUIDropdownFooter;
}());
ISPUIDropdownFooter.style = css$2;
var css$3 = ".ispui-dropdown-header{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;padding:var(--ispui-dropdown-header-padding, 20px 20px 0 20px)}.ispui-dropdown-popup_has-cross .ispui-dropdown-header{padding:var(--ispui-dropdown-header-padding, 20px 55px 0 20px)}";
var ISPUIDropdownHeader = /** @class */ (function () {
    function ISPUIDropdownHeader(hostRef) {
        registerInstance(this, hostRef);
    }
    ISPUIDropdownHeader.prototype.render = function () {
        return (h(Host, { slot: "dropdown-header", class: "ispui-dropdown-header" }, h("slot", null)));
    };
    return ISPUIDropdownHeader;
}());
ISPUIDropdownHeader.style = css$3;
var css$4 = ":host{position:absolute;display:inline-block;min-width:var(--ispui-dropdown-min-width, 200px);max-width:var(--ispui-dropdown-max-width, 640px);min-height:var(--ispui-dropdown-min-height, 60px);max-height:var(--ispui-dropdown-max-height, calc(100vh - 40px));-webkit-animation:fade-in var(--ispui-dropdown-animation-duration, 0.4s) ease 1 forwards;animation:fade-in var(--ispui-dropdown-animation-duration, 0.4s) ease 1 forwards;opacity:0}:host(.ispui-dropdown_closing){-webkit-animation:fade-out var(--ispui-dropdown-animation-duration, 0.4s) ease 1 forwards;animation:fade-out var(--ispui-dropdown-animation-duration, 0.4s) ease 1 forwards}@-webkit-keyframes fade-in{0%{opacity:0}100%{opacity:1}}@keyframes fade-in{0%{opacity:0}100%{opacity:1}}@-webkit-keyframes fade-out{0%{opacity:1}100%{opacity:0}}@keyframes fade-out{0%{opacity:1}100%{opacity:0}}.ispui-dropdown__close-btn{position:absolute;top:var(--ispui-dropdown-close-top, 15px);right:var(--ispui-dropdown-close-right, 15px)}.ispui-dropdown-popup__container{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-height:100%;max-height:100%;border-radius:var(--ispui-dropdown-border-radius, 5px);background-color:var(--ispui-dropdown-bg-color, #ffffff);-webkit-box-shadow:-1px 2px 7px rgba(52, 74, 94, 0.56);box-shadow:-1px 2px 7px rgba(52, 74, 94, 0.56)}.ispui-dropdown-popup_has-pointer{height:calc(100% - 20px);min-height:calc(100% - 20px);max-height:calc(100% - 20px);margin-top:20px}:host(.ispui-dropdown-popup__direction_top) .ispui-dropdown-popup_has-pointer{margin:0 0 20px 0}:host(.ispui-dropdown-popup__direction_left) .ispui-dropdown_has-pointer{width:calc(100% - 20px);height:100%;max-height:100%;margin:0 20px 0 0}:host(.ispui-dropdown-popup__direction_right) .ispui-dropdown_has-pointer{width:calc(100% - 20px);height:100%;max-height:100%;margin:0 0 0 20px}.ispui-dropdown__pointer{position:absolute;top:1px;left:var(--ispui-dropdown__pointer-left, 50%);overflow:hidden;width:34px;height:22px;-webkit-transform:translateY(-100%);transform:translateY(-100%)}.ispui-dropdown__pointer::before{content:\"\";position:absolute;bottom:0;left:50%;width:18px;height:18px;-webkit-transform:translate(-50%, 50%) rotate(45deg) skew(8deg, 8deg) scale(1.3);transform:translate(-50%, 50%) rotate(45deg) skew(8deg, 8deg) scale(1.3);background-color:var(--ispui-dropdown-bg-color, #ffffff);-webkit-box-shadow:0 0 3px rgba(52, 74, 94, 0.35);box-shadow:0 0 3px rgba(52, 74, 94, 0.35)}:host(.ispui-dropdown-popup__direction_left) .ispui-dropdown__pointer{top:var(--ispui-dropdown__pointer-top, 50%);left:100%;-webkit-transform:translate(-18%, 25%) rotateZ(90deg);transform:translate(-18%, 25%) rotateZ(90deg);-webkit-transform-origin:center;transform-origin:center}:host(.ispui-dropdown-popup__direction_right) .ispui-dropdown__pointer{top:var(--ispui-dropdown__pointer-top, 50%);left:0;-webkit-transform:translate(-81%, 25%) rotateZ(-90deg);transform:translate(-81%, 25%) rotateZ(-90deg);-webkit-transform-origin:center;transform-origin:center}:host(.ispui-dropdown-popup__direction_top) .ispui-dropdown__pointer{top:calc(100% - 1px);-webkit-transform:rotate(180deg);transform:rotate(180deg)}:host(.ispui-dropdown-popup__direction_top) .ispui-dropdown__pointer::before{-webkit-box-shadow:1px 0 6px rgba(52, 74, 94, 0.56);box-shadow:1px 0 6px rgba(52, 74, 94, 0.56)}";
var ISPUIDropdownPopup = /** @class */ (function () {
    function ISPUIDropdownPopup(hostRef) {
        registerInstance(this, hostRef);
        /** Flag for handle close button existence */
        this.isClose = true;
        /** Flag for handle pointer existence */
        this.hasPointer = true;
        /** Dropdown direction */
        this.direction = 'bottom';
        /** Dropdown z-index */
        this.zIndex = 100;
        this.closeClicked = createEvent(this, "closeClicked", 7);
    }
    /**
     * Emit event when close button clicked
     */
    ISPUIDropdownPopup.prototype.handleCloseClick = function () {
        this.closeClicked.emit(null);
    };
    ISPUIDropdownPopup.prototype.render = function () {
        var _this = this;
        var hostClasses = [];
        this.isClose && hostClasses.push('ispui-dropdown-popup_has-cross');
        this.hasPointer && hostClasses.push('ispui-dropdown-popup_has-pointer');
        this.direction && hostClasses.push("ispui-dropdown-popup__direction_" + this.direction);
        return (h(Host, { class: hostClasses.join(' '), style: { zIndex: String(this.zIndex) } }, h("div", { class: "ispui-dropdown-popup__container " + (this.hasPointer ? 'ispui-dropdown-popup__container_has-pointer' : '') }, h("slot", { name: "dropdown-header" }), h("slot", null), h("slot", { name: "dropdown-footer" }), this.hasPointer && h("div", { class: "ispui-dropdown__pointer" }), this.isClose && (h("ispui-close", { class: "ispui-dropdown__close-btn", onClick: function () { return _this.handleCloseClick(); }, theme: CloseBtnTheme.gray })))));
    };
    return ISPUIDropdownPopup;
}());
ISPUIDropdownPopup.style = css$4;
export { MyComponent as ispui_close, ISPUIDropdown as ispui_dropdown, ISPUIDropdownContent as ispui_dropdown_content, ISPUIDropdownFooter as ispui_dropdown_footer, ISPUIDropdownHeader as ispui_dropdown_header, ISPUIDropdownPopup as ispui_dropdown_popup };
